import { useSearchParams } from 'react-router-dom'

// type ParamsToObjResponse = <Type>(params: Type[]) => Partial<Type & { counter: number }>

function IsJsonString(str: string) {
  try {
    return JSON.parse(str)
  } catch (e) {
    return str
  }
}

export function useParamsToObj<Type>(params: string[]): Partial<Type | (any & { counter: number })> {
  const [searchParams] = useSearchParams()

  let counter = 0

  const obj: any = {}

  params.forEach((param) => {
    const val = searchParams.get(param)

    if (val) {
      const transformData = IsJsonString(val)

      obj[param] = transformData.toString()

      if (param !== 'search') {
        counter += 1
      }
    }
  })

  return { ...obj, counter } as Partial<Type | (any & { counter: number })>
}
